(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  var backdrop = document.querySelector('.cart-drawer-backdrop');
  var itemsEl = drawer.querySelector('[data-cart-items]');
  var emptyEl = drawer.querySelector('[data-cart-empty]');
  var summaryEl = drawer.querySelector('[data-cart-summary]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var shippingEl = drawer.querySelector('[data-cart-shipping]');
  var totalEl = drawer.querySelector('[data-cart-total]');
  var shipEl = drawer.querySelector('[data-cart-ship]');
  var shipTextEl = drawer.querySelector('[data-cart-ship-text]');
  var shipBarEl = drawer.querySelector('[data-cart-ship-bar]');
  var shipFillEl = drawer.querySelector('[data-cart-ship-fill]');
  var shipTruckEl = drawer.querySelector('[data-cart-ship-truck]');
  var errorEl = drawer.querySelector('[data-cart-error]');
  var discountLineEl = drawer.querySelector('[data-cart-discount-line]');
  var discountEl = drawer.querySelector('[data-cart-discount]');
  var promoFormEl = drawer.querySelector('[data-cart-promo-form]');
  var promoInputEl = drawer.querySelector('[data-cart-promo-input]');
  var promoApplyEl = drawer.querySelector('[data-cart-promo-apply]');
  var promoErrorEl = drawer.querySelector('[data-cart-promo-error]');
  var promoTagsEl = drawer.querySelector('[data-cart-promo-tags]');
  var upgradeEl = drawer.querySelector('[data-cart-upgrade]');
  var upgradeTextEl = drawer.querySelector('[data-cart-upgrade-text]');
  var thresholdCents = (parseFloat(drawer.dataset.freeShipThreshold) || 0) * 100;
  // Below the free-ship threshold the cost depends on the buyer's location and is
  // resolved at checkout — never a hardcoded flat fee.
  var SHIP_CALC_HTML = '<span class="cart-drawer__ship-calc">Calculée à l\'étape suivante</span>';
  var upgrading = false;
  var upgradeTimer = null;
  var lastAddedKey = null;
  var lastCart = null;
  // Inline truck SVG reused by the unlocked free-ship badge (matches the SSR markup).
  var TRUCK_SVG = '<svg class="cart-drawer__truck" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
  // Monotonic guard: a slow/older /cart.js response can never overwrite a newer one.
  var seqCounter = 0;
  var lastApplied = 0;

  var currency = drawer.dataset.currency || 'EUR';
  var locale = document.documentElement.lang || 'fr-FR';
  function money(cents) {
    // Format per-currency so the symbol lands where that currency expects it:
    // EUR → French style "24,99 €" (symbol after, comma decimal); USD → "$24.99".
    var loc = currency === 'EUR' ? 'fr-FR' : (currency === 'USD' ? 'en-US' : locale);
    try {
      return new Intl.NumberFormat(loc, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }
  function escapeHtml(s) {
    var div = document.createElement('div');
    div.textContent = s == null ? '' : s;
    return div.innerHTML;
  }
  // Resize cart thumbnails through Shopify's image CDN (cart.js returns full-size URLs).
  function sizedImage(url, w) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', w);
      return u.href;
    } catch (e) { return url; }
  }
  // ── Mono-product pack model (1 / 3 / 5 flacons) for the in-cart switcher ──
  var mcPacks = [];
  try {
    var mcCfgEl = drawer.querySelector('[data-mc-packs]');
    if (mcCfgEl) mcPacks = JSON.parse(mcCfgEl.textContent) || [];
  } catch (e) { mcPacks = []; }
  function packFor(variantId) {
    for (var i = 0; i < mcPacks.length; i++) {
      if (String(mcPacks[i].id) === String(variantId)) return mcPacks[i];
    }
    return null;
  }
  function flaconLabel(n) { return n > 1 ? n + ' flacons' : n + ' flacon'; }
  function singleUnitCents() {
    for (var i = 0; i < mcPacks.length; i++) { if (mcPacks[i].flacons === 1) return mcPacks[i].price; }
    return 0;
  }
  // Savings = per-flacon price vs the single-flacon price (the real "buy bigger" deal).
  function packSavings(p) {
    var base = singleUnitCents();
    if (!base || !p || p.flacons <= 1) return 0;
    var per = p.price / p.flacons;
    if (per >= base) return 0;
    return Math.floor((base - per) * 100 / base);
  }
  // Line subtitle for an MC line: total flacons (when qty>1) + per-flacon price.
  function mcSubtitleHtml(pack, unitCents, qty) {
    if (!pack || pack.flacons <= 0) return '';
    var per = money(Math.round(unitCents / pack.flacons));
    var total = pack.flacons * qty;
    return (qty > 1 ? '<strong>' + total + ' flacons</strong> · ' : '') + 'soit ' + per + '/flacon';
  }
  function packsSwitcherHtml(key, currentVariantId) {
    if (!mcPacks.length) return '';
    var html = '<div class="cart-drawer__packs" role="group" aria-label="Choisir le pack">';
    mcPacks.forEach(function (p) {
      var active = String(p.id) === String(currentVariantId);
      var save = packSavings(p);
      html += '<button type="button" class="cart-drawer__pack' + (active ? ' is-active' : '') + '"' +
        ' data-pack-switch data-key="' + escapeHtml(key) + '" data-variant="' + p.id + '"' +
        (active ? ' aria-current="true"' : '') + (p.available ? '' : ' disabled') + '>' +
        '<span class="cart-drawer__pack-n">' + flaconLabel(p.flacons) + '</span>' +
        '<span class="cart-drawer__pack-price">' + money(p.price) + '</span>' +
        (save > 0 ? '<span class="cart-drawer__pack-save">−' + save + '%</span>' : '') +
      '</button>';
    });
    return html + '</div>';
  }
  // Switch a line to another pack tier without remove + re-add (atomic /cart/update.js).
  // Picking a pack tile means "I want THIS pack" → 1 of the new tier (merged with any
  // existing line of that tier), NOT the old line's quantity (so 3 singles → 5-pack ×1,
  // not ×3). Bump the stepper afterwards for multiples.
  function switchPack(key, newVariantId) {
    if (!lastCart) return;
    var line = null;
    lastCart.items.forEach(function (i) { if (i.key === key) line = i; });
    if (!line || String(line.variant_id) === String(newVariantId)) return;
    var oldId = line.variant_id;
    var existingNew = 0;
    lastCart.items.forEach(function (i) { if (String(i.variant_id) === String(newVariantId)) existingNew += i.quantity; });
    clearError();
    // Optimistic: move the active highlight + dim the line until the server reconciles.
    var row = itemsEl.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (row) {
      row.querySelectorAll('[data-pack-switch]').forEach(function (b) {
        b.classList.toggle('is-active', String(b.dataset.variant) === String(newVariantId));
      });
      row.classList.add('is-updating');
    }
    var updates = {};
    updates[oldId] = 0;
    updates[newVariantId] = 1 + existingNew;
    enqueue(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { applyCart(c, ++seqCounter); })
        .catch(function () { return refresh(); });
    });
  }

  // ── Value ladder: stepping +/− walks the best-deal ladder (1 → 2 → 5 → 9 → 18…)
  //    and auto-upgrades the pack tier, instead of just multiplying the current pack. ──
  function packByFlacons(n) {
    for (var i = 0; i < mcPacks.length; i++) { if (mcPacks[i].flacons === n) return mcPacks[i]; }
    return null;
  }
  // Next/prev rung as {id, qty}. Returns null if the ladder isn't available.
  function ladderNext(variantId, qty) {
    var s = packByFlacons(1), p5 = packByFlacons(5), p9 = packByFlacons(9);
    if (!s || !p5 || !p9) return null;
    var vid = String(variantId);
    if (vid === String(s.id)) { return qty <= 1 ? { id: s.id, qty: 2 } : { id: p5.id, qty: 1 }; }
    if (vid === String(p5.id)) { return qty <= 1 ? { id: p9.id, qty: 1 } : { id: p5.id, qty: qty + 1 }; }
    if (vid === String(p9.id)) { return { id: p9.id, qty: qty + 1 }; }
    return { id: variantId, qty: qty + 1 };
  }
  function ladderPrev(variantId, qty) {
    var s = packByFlacons(1), p5 = packByFlacons(5), p9 = packByFlacons(9);
    if (!s || !p5 || !p9) return null;
    var vid = String(variantId);
    if (vid === String(s.id)) { return { id: s.id, qty: qty - 1 }; }            // 2→1, 1→0 (remove)
    if (vid === String(p5.id)) { return qty <= 1 ? { id: s.id, qty: 2 } : { id: p5.id, qty: qty - 1 }; }
    if (vid === String(p9.id)) { return qty <= 1 ? { id: p5.id, qty: 1 } : { id: p9.id, qty: qty - 1 }; }
    return { id: variantId, qty: qty - 1 };
  }
  function showToast(html) {
    if (!upgradeEl || !upgradeTextEl) return;
    upgradeTextEl.innerHTML = html;
    upgradeEl.hidden = false;
    upgradeEl.style.animation = 'none';
    void upgradeEl.offsetWidth; // restart the pop
    upgradeEl.style.animation = '';
    if (upgradeTimer) clearTimeout(upgradeTimer);
    upgradeTimer = setTimeout(function () { upgradeEl.hidden = true; }, 5000);
  }
  // Celebrate landing on a pack with free ("offerts") flacons.
  function offertsToast(newVariantId, oldVariantId) {
    var np = packFor(newVariantId), op = packFor(oldVariantId);
    if (!np || !np.offerts || np.offerts <= 0) return;
    if (op && op.flacons >= np.flacons) return; // only when moving UP a tier
    showToast('<strong>' + np.offerts + ' flacon' + (np.offerts > 1 ? 's' : '') + ' offert' + (np.offerts > 1 ? 's' : '') + ' !</strong> Tu passes au pack ' + np.flacons + ' flacons.');
  }
  // Step a Magic Clean line along the value ladder (variant change when it crosses a tier).
  function ladderStep(key, dir) {
    if (!lastCart) return;
    var line = null;
    lastCart.items.forEach(function (i) { if (i.key === key) line = i; });
    if (!line) return;
    var target = dir > 0 ? ladderNext(line.variant_id, line.quantity) : ladderPrev(line.variant_id, line.quantity);
    if (!target) { changeQty(key, line.quantity + dir); return; }
    if (target.qty <= 0) { changeQty(key, 0); return; }
    if (String(target.id) === String(line.variant_id)) { changeQty(key, target.qty); return; }
    // Crossing a tier → atomic variant swap (merge with any existing line of the target).
    clearError();
    var existing = 0;
    lastCart.items.forEach(function (i) { if (String(i.variant_id) === String(target.id)) existing += i.quantity; });
    var row = itemsEl.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (row) row.classList.add('is-updating');
    if (dir > 0) offertsToast(target.id, line.variant_id);
    var updates = {};
    updates[line.variant_id] = 0;
    updates[target.id] = target.qty + existing;
    enqueue(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { applyCart(c, ++seqCounter); })
        .catch(function () { return refresh(); });
    });
  }
  // Safety net: any cart holding ≥3 single flacons auto-snaps to the 5-pack (more
  // flacons, lower price). Catches PDP adds; the in-drawer ladder never makes 3 singles.
  function maybeUpgrade(cart) {
    if (upgrading) return;
    var s = packByFlacons(1), p5 = packByFlacons(5);
    if (!s || !p5) return;
    var singleQty = 0, packQty = 0;
    (cart.items || []).forEach(function (it) {
      if (String(it.variant_id) === String(s.id)) singleQty += it.quantity;
      if (String(it.variant_id) === String(p5.id)) packQty += it.quantity;
    });
    if (singleQty < 3) return;
    upgrading = true;
    offertsToast(p5.id, s.id);
    var updates = {};
    updates[s.id] = 0;
    updates[p5.id] = packQty + 1;
    enqueue(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { upgrading = false; applyCart(c, ++seqCounter); })
        .catch(function () { upgrading = false; return refresh(); });
    });
  }

  function updateCounts(n) {
    document.querySelectorAll('[data-cart-count], .header__cart-count, .shpCartCount').forEach(function (el) {
      el.textContent = n;
    });
    document.querySelectorAll('.header__cart[aria-label]').forEach(function (el) {
      el.setAttribute('aria-label', 'Panier (' + n + ')');
    });
  }
  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }
  function clearError() {
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
  }

  // Serialize every cart write so concurrent add / change requests never race
  // the cart token (which can silently drop an update).
  var chain = Promise.resolve();
  function enqueue(task) {
    var run = chain.then(task, task);
    chain = run.catch(function () {});
    return run;
  }
  // Per-line debounce: rapid +/- clicks collapse into one server request.
  var timers = {};
  var pending = {};

  function renderShipping(totalCents, count) {
    if (!shipEl) return;
    if (!thresholdCents || count === 0) { shipEl.hidden = true; return; }
    shipEl.hidden = false;
    var pct = Math.min(100, Math.round(totalCents * 100 / thresholdCents));
    var remaining = thresholdCents - totalCents;
    if (remaining > 0) {
      shipEl.classList.remove('is-done');
      shipTextEl.innerHTML = 'Plus que <strong>' + money(remaining) + '</strong> pour la livraison offerte';
    } else {
      shipEl.classList.add('is-done');
      shipTextEl.innerHTML = '<span class="cart-drawer__ship-badge">' + TRUCK_SVG + '<span>Livraison offerte débloquée !</span></span>';
    }
    shipBarEl.setAttribute('aria-valuenow', pct);
    shipFillEl.style.width = pct + '%';
    if (shipTruckEl) shipTruckEl.style.left = pct + '%';
  }

  function render(cart) {
    if (!cart) return;
    currency = cart.currency || currency;
    itemsEl.innerHTML = '';
    if (cart.item_count === 0) {
      emptyEl.style.display = 'flex';
      summaryEl.hidden = true;
      if (shipEl) shipEl.hidden = true;
      lastAddedKey = null;
      return;
    }
    emptyEl.style.display = 'none';
    summaryEl.hidden = false;
    renderShipping(cart.total_price, cart.item_count);

    cart.items.forEach(function (item) {
      // Magic Clean mono-product → in-cart pack switcher + per-flacon hint.
      var pack = packFor(item.variant_id);
      var detail;
      if (pack) {
        var per = pack.flacons > 0
          ? '<p class="cart-drawer__item-sub">' + mcSubtitleHtml(pack, item.final_price, item.quantity) + '</p>'
          : '';
        detail = per + packsSwitcherHtml(item.key, item.variant_id);
      } else {
        detail = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';
      }
      var row = document.createElement('div');
      row.className = 'cart-drawer__item' + (pack ? ' cart-drawer__item--packs' : '');
      row.dataset.key = item.key;
      row.dataset.unit = item.final_price;
      if (pack) { row.dataset.mcLine = ''; row.dataset.variant = item.variant_id; }
      if (lastAddedKey && item.key === lastAddedKey) row.classList.add('is-new');
      row.innerHTML =
        '<a class="cart-drawer__item-thumb" href="' + escapeHtml(item.url) + '">' +
          (item.image ? '<img src="' + escapeHtml(sizedImage(item.image, 140)) + '" alt="" width="70" height="70" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-drawer__item-meta">' +
          '<div class="cart-drawer__item-head">' +
            '<p class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>' +
            '<p class="cart-drawer__item-price">' + money(item.final_line_price) + '</p>' +
          '</div>' +
          detail +
          '<div class="cart-drawer__item-bottom">' +
            '<div class="cart-drawer__qty' + (pack ? ' cart-drawer__qty--flacons' : '') + '">' +
              '<button type="button" data-qty-down data-key="' + escapeHtml(item.key) + '" aria-label="' + (pack ? 'Moins de flacons' : 'Diminuer') + '">−</button>' +
              '<span>' + (pack ? pack.flacons * item.quantity + ' fl.' : item.quantity) + '</span>' +
              '<button type="button" data-qty-up data-key="' + escapeHtml(item.key) + '" aria-label="' + (pack ? 'Plus de flacons' : 'Augmenter') + '">+</button>' +
            '</div>' +
            '<button type="button" class="cart-drawer__item-remove" data-qty-remove data-key="' + escapeHtml(item.key) + '">Retirer</button>' +
          '</div>' +
        '</div>';
      itemsEl.appendChild(row);
    });
    lastAddedKey = null;

    subtotalEl.textContent = money(cart.items_subtotal_price);
    if (thresholdCents && cart.total_price >= thresholdCents) {
      shippingEl.innerHTML = '<span class="is-free">Offerte</span>';
    } else {
      shippingEl.innerHTML = SHIP_CALC_HTML;
    }
    renderDiscounts(cart);
    totalEl.textContent = money(cart.total_price);
  }

  // Applied discount codes (chips + the "Réduction" summary line).
  function renderDiscounts(cart) {
    var codes = (cart.discount_codes || []).filter(function (d) { return d && d.applicable; });
    var totalDisc = cart.total_discount || 0;
    if (promoTagsEl) {
      promoTagsEl.innerHTML = codes.map(function (d) {
        // /cart.js doesn't reliably populate a per-code amount (order-level % codes
        // report 0). For a single code the true saving is cart.total_discount; if we
        // genuinely can't attribute an amount, show the chip without one (no "−0 €").
        var amt = (d.amount && d.amount > 0) ? d.amount : (codes.length === 1 ? totalDisc : 0);
        var amtHtml = amt > 0 ? '<span class="cart-drawer__promo-amount">−' + money(amt) + '</span>' : '';
        return '<span class="cart-drawer__promo-tag">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' +
          '<span class="cart-drawer__promo-code">' + escapeHtml(d.code) + '</span>' +
          amtHtml +
          '<button type="button" class="cart-drawer__promo-remove" data-cart-promo-remove="' + escapeHtml(d.code) + '" aria-label="Retirer le code ' + escapeHtml(d.code) + '">×</button>' +
        '</span>';
      }).join('');
    }
    if (discountLineEl) {
      if (cart.total_discount > 0) {
        discountLineEl.hidden = false;
        if (discountEl) discountEl.textContent = '−' + money(cart.total_discount);
      } else {
        discountLineEl.hidden = true;
      }
    }
  }

  // Apply a server cart snapshot, but only if it's newer than the last one
  // painted (drops out-of-order responses).
  function applyCart(cart, seq) {
    if (!cart) return;
    if (seq < lastApplied) return; // a newer snapshot already won — drop this one
    lastApplied = seq;
    lastCart = cart;
    render(cart);
    updateCounts(cart.item_count);
    maybeUpgrade(cart);
  }

  function refresh() {
    var seq = ++seqCounter;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyCart(cart, seq); return cart; })
      .catch(function () {});
  }

  function open(skipRefresh) {
    clearError();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.hidden = false;
    document.body.style.overflow = 'hidden';
    if (!skipRefresh) refresh();
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.hidden = true;
    document.body.style.overflow = '';
  }

  // Recompute totals/shipping/badges from what's currently on screen (optimistic)
  function recomputeTotals() {
    var rows = itemsEl.querySelectorAll('.cart-drawer__item');
    var subtotal = 0, count = 0;
    rows.forEach(function (r) {
      var shown = parseInt(r.querySelector('.cart-drawer__qty span').textContent, 10) || 0;
      var unit = parseInt(r.dataset.unit, 10) || 0;
      // MC lines display flacons in the stepper → convert back to pack quantity.
      var q = shown;
      if (r.dataset.mcLine !== undefined) {
        var p = packFor(r.dataset.variant);
        q = (p && p.flacons > 0) ? Math.round(shown / p.flacons) : shown;
      }
      subtotal += q * unit;
      count += q;
    });
    if (count === 0) {
      emptyEl.style.display = 'flex';
      summaryEl.hidden = true;
      if (shipEl) shipEl.hidden = true;
    } else {
      subtotalEl.textContent = money(subtotal);
      // With an active discount code we can't reliably recompute the discounted
      // total client-side — leave it to the server reconcile (lands within ~300ms).
      if (!lastCart || !(lastCart.total_discount > 0)) {
        totalEl.textContent = money(subtotal);
      }
      if (thresholdCents && subtotal >= thresholdCents) {
        shippingEl.innerHTML = '<span class="is-free">Offerte</span>';
      } else {
        shippingEl.innerHTML = SHIP_CALC_HTML;
      }
      renderShipping(subtotal, count);
    }
    updateCounts(count);
  }

  // ── Discount code (apply / remove via /cart/update.js `discount`) ──
  function currentCodes() {
    if (!lastCart || !lastCart.discount_codes) return [];
    return lastCart.discount_codes
      .filter(function (d) { return d && d.applicable; })
      .map(function (d) { return d.code; });
  }
  function promoBusy(on) {
    if (!promoApplyEl) return;
    if (on) promoApplyEl.classList.add('is-busy');
    else promoApplyEl.classList.remove('is-busy');
  }
  function showPromoError(msg) {
    if (!promoErrorEl) return;
    promoErrorEl.textContent = msg;
    promoErrorEl.hidden = false;
  }
  function clearPromoError() {
    if (promoErrorEl) { promoErrorEl.hidden = true; promoErrorEl.textContent = ''; }
  }
  function updateDiscounts(codes) {
    return enqueue(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function (r) { return r.json(); });
    });
  }
  function applyPromo(raw) {
    var code = (raw || '').trim();
    if (!code) return;
    clearPromoError();
    promoBusy(true);
    var keep = currentCodes();
    var next = keep.slice();
    var exists = next.some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
    if (!exists) next.push(code);
    updateDiscounts(next)
      .then(function (cart) {
        var entry = (cart.discount_codes || []).filter(function (d) {
          return d.code && d.code.toLowerCase() === code.toLowerCase();
        })[0];
        if (!entry || !entry.applicable) {
          showPromoError('Code invalide ou non applicable.');
          // Clean up the rejected code so it can't surface at checkout.
          return updateDiscounts(keep).then(function (c) { applyCart(c, ++seqCounter); });
        }
        if (promoInputEl) promoInputEl.value = '';
        applyCart(cart, ++seqCounter);
      })
      .catch(function () { showPromoError('Oups, réessaie dans un instant.'); })
      .then(function () { promoBusy(false); });
  }
  function removePromo(code) {
    var next = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    clearPromoError();
    updateDiscounts(next)
      .then(function (cart) { applyCart(cart, ++seqCounter); })
      .catch(function () { return refresh(); });
  }

  // Instant UI update, then debounced + serialized server sync (feels immediate,
  // never races another cart write).
  function changeQty(key, qty) {
    clearError();
    var row = itemsEl.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (row) {
      if (qty <= 0) {
        row.parentNode.removeChild(row);
      } else {
        var span = row.querySelector('.cart-drawer__qty span');
        var unit = parseInt(row.dataset.unit, 10) || 0;
        var priceEl = row.querySelector('.cart-drawer__item-price');
        if (priceEl) priceEl.textContent = money(unit * qty);
        // MC lines show flacons (not pack count) in the stepper + keep the subtitle live.
        if (row.dataset.mcLine !== undefined) {
          var p = packFor(row.dataset.variant);
          if (span && p) span.textContent = p.flacons * qty + ' fl.';
          var subEl = row.querySelector('.cart-drawer__item-sub');
          if (subEl && p) subEl.innerHTML = mcSubtitleHtml(p, unit, qty);
        } else if (span) {
          span.textContent = qty;
        }
      }
    }
    recomputeTotals();

    pending[key] = qty;
    if (timers[key]) clearTimeout(timers[key]);
    timers[key] = setTimeout(function () {
      delete timers[key];
      var target = pending[key];
      delete pending[key];
      enqueue(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: target })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCounts(cart.item_count);
            // Repaint from the server only once every queued change has settled,
            // so rapid clicks are never clobbered mid-flight. A fresh top sequence
            // makes this win over any older in-flight refresh.
            if (Object.keys(timers).length === 0) applyCart(cart, ++seqCounter);
          })
          .catch(function () { return refresh(); });
      });
    }, 300);
  }

  // Expose globally so add-to-cart elsewhere can open the drawer
  window.MagicCleanCart = { open: open, close: close, refresh: refresh };

  // The initial cart is rendered server-side (Liquid) so the drawer is correct
  // the instant the page paints — even before this script runs. Sync once on
  // load while the drawer is closed (invisible) to normalise money formatting
  // and pick up any out-of-band changes.
  refresh();

  // Intercept every add-to-cart form (PDP, kits…). The panel slides in
  // IMMEDIATELY (covering the network latency), then the added line is fetched
  // and painted — so it feels instant. Validation errors (e.g. out of stock)
  // surface inline; a hard network failure falls back to a native submit.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    // Discount code form — apply via AJAX, never navigate.
    if (form.matches('[data-cart-promo-form]')) {
      e.preventDefault();
      applyPromo(promoInputEl ? promoInputEl.value : '');
      return;
    }
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"], [name="add"]');
    if (btn) { btn.classList.add('is-adding'); btn.disabled = true; }
    // Open right away (skip the auto-refresh — the add flow owns the repaint).
    open(true);
    enqueue(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (r.ok) return r.json();
          // Shopify returns a JSON body with `description` on 422 (e.g. sold out).
          return r.json().then(function (err) { throw err; });
        })
        .then(function (item) {
          lastAddedKey = item.key || null;
          return refresh();
        })
        .catch(function (err) {
          if (err && err.description) { showError(err.description); return refresh(); }
          // Network/parse failure → let the browser add it the classic way.
          form.submit();
        })
        .finally(function () { if (btn) { btn.classList.remove('is-adding'); btn.disabled = false; } });
    });
  }, true);

  // Open triggers
  document.addEventListener('click', function (e) {
    var openEl = e.target.closest('[data-cart-open], .header__cart');
    if (openEl) { e.preventDefault(); open(); return; }
    var closeEl = e.target.closest('[data-cart-close]');
    if (closeEl && !closeEl.href) { e.preventDefault(); }
    if (closeEl) { close(); return; }
    var promoRemoveEl = e.target.closest('[data-cart-promo-remove]');
    if (promoRemoveEl) { e.preventDefault(); removePromo(promoRemoveEl.getAttribute('data-cart-promo-remove')); return; }
    var packEl = e.target.closest('[data-pack-switch]');
    if (packEl) { e.preventDefault(); if (!packEl.disabled) switchPack(packEl.dataset.key, packEl.dataset.variant); return; }
    var removeEl = e.target.closest('[data-qty-remove]');
    if (removeEl) { changeQty(removeEl.dataset.key, 0); return; }
    var down = e.target.closest('[data-qty-down]');
    if (down) {
      var drow = down.closest('.cart-drawer__item');
      if (drow && drow.dataset.mcLine !== undefined) { ladderStep(down.dataset.key, -1); return; }
      var span = down.parentElement.querySelector('span');
      changeQty(down.dataset.key, Math.max(0, parseInt(span.textContent, 10) - 1));
      return;
    }
    var up = e.target.closest('[data-qty-up]');
    if (up) {
      var urow = up.closest('.cart-drawer__item');
      if (urow && urow.dataset.mcLine !== undefined) { ladderStep(up.dataset.key, 1); return; }
      var span2 = up.parentElement.querySelector('span');
      changeQty(up.dataset.key, parseInt(span2.textContent, 10) + 1);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // Mono-product store: the /cart page redirects here as /?cart=open so the
  // cart is shown via THIS drawer (no standalone cart page). Open it, then
  // strip the param so refresh/back doesn't re-trigger.
  try {
    if (/[?&]cart=open(&|$)/.test(window.location.search)) {
      open();
      if (window.history && history.replaceState) {
        history.replaceState(null, '', window.location.pathname);
      }
    }
  } catch (e) {}
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-pack-cta"] && !Shopify.designMode) return;
  try {
    (function () {
  var cta = document.querySelector('[data-mc-packcta]');
  if (!cta) return;

  var targetSel = cta.getAttribute('data-target') || '#nos-packs';
  var heroSel = cta.getAttribute('data-hero') || '';
  var target = document.querySelector(targetSel);
  var hero = heroSel ? document.querySelector(heroSel) : null;
  if (!target) return; // nothing to scroll to → never show

  var heroPassed = false;
  var packsVisible = false;

  function update() {
    var show = heroPassed && !packsVisible;
    cta.classList.toggle('is-visible', show);
    cta.setAttribute('aria-hidden', show ? 'false' : 'true');
    cta.tabIndex = show ? 0 : -1;
  }

  if ('IntersectionObserver' in window) {
    // The packs section being on screen hides the pill.
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { packsVisible = e.isIntersecting; update(); });
    }, { threshold: 0.12 }).observe(target);

    if (hero) {
      // "Passed" = hero has scrolled above the top of the viewport.
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          heroPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
          update();
        });
      }, { threshold: 0 }).observe(hero);
    } else {
      heroPassed = true;
      update();
    }
  } else {
    // Legacy fallback: reveal after roughly one viewport of scroll.
    window.addEventListener('scroll', function () {
      heroPassed = window.scrollY > window.innerHeight * 0.8;
      update();
    }, { passive: true });
  }

  cta.addEventListener('click', function (e) {
    e.preventDefault();
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
